import axios from 'axios'
import axiosRetry from 'axios-retry'
import { FINGERPRINT_HASH_SEED, REQUEST_RETRIES_DEFAULT } from './constants'
import { removeSessionIfTokenHasExpired } from 'state/helpers'
import { x64hash128 } from 'fingerprintjs2'

export const createHttp = (baseURL: any) => {
  const client = axios.create({ baseURL })
  client.interceptors.response.use(
    response => response,
    error => {
      removeSessionIfTokenHasExpired(error)
      return Promise.reject(error)
    }
  )
  axiosRetry(client, { retries: REQUEST_RETRIES_DEFAULT })
  return client
}

export const getHashFromString = (value: string, seed: number = FINGERPRINT_HASH_SEED): string =>
  x64hash128(value, seed)
